import { toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "checkbox" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _createTextVNode(_toDisplayString(_ctx.label && _ctx.label) + " ", 1),
    (_ctx.type === 'value')
      ? _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 0,
          type: "checkbox",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('change', [($event.target as HTMLInputElement).checked, _ctx.label])))
        }, null, 544)), [
          [_vModelCheckbox, _ctx.value]
        ])
      : _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 1,
          type: "checkbox",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.checkbox) = $event)),
          onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('change', [($event.target as HTMLInputElement).checked, _ctx.label])))
        }, null, 544)), [
          [_vModelCheckbox, _ctx.checkbox]
        ]),
    _createElementVNode("span", {
      style: _normalizeStyle({'border-color': _ctx.borderColor}),
      class: "checkmark"
    }, null, 4)
  ]))
}